module.exports = __webpack_public_path__ + "static/media/machine_broadcast.74da0c7d.svg";